import { withStyles, Divider as MuiDivider } from '@material-ui/core';

export const Divider = withStyles({
  root: {
    backgroundColor: '#C4C4C4',
  },
})(MuiDivider);
